import { atom } from 'jotai';

import {
  type CancellationReason,
  type RecordCancellationIntentResponse,
} from '../../contracts';

export type CancelFlowContext = {
  flowId: string;
  stripeSubscriptionId: string;
  /** Reason step; drives offer copy + analytics. */
  selectedReason?: CancellationReason;
  /** Intent API response; routes discount / clinician offers. */
  offerResponse: RecordCancellationIntentResponse | null;
};

export const cancelFlowContextAtom = atom<CancelFlowContext | null>(null);
